import { z } from "zod";

export const importProductSchema = z.object({
  name: z.string().min(1),
});

export const defaultImportProductValues = {
  name: "",
};

export type ImportProductForm = z.infer<typeof importProductSchema>;
